import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const Ctx = createContext(null);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/settings`)
      .then((r) => setSettings(r.data))
      .catch(() => setSettings({}));
  }, []);

  const waLink = (serviceName) => {
    if (!settings?.whatsapp) return null;
    const text = serviceName
      ? `Buongiorno FLASH, vorrei informazioni sul servizio ${serviceName}.`
      : "Buongiorno FLASH, avrei bisogno di informazioni sui vostri servizi.";
    return `https://wa.me/${settings.whatsapp}?text=${encodeURIComponent(text)}`;
  };

  const value = {
    settings,
    ready: settings !== null,
    waLink,
    hasWhatsapp: Boolean(settings?.whatsapp),
    hasPhone: Boolean(settings?.phone),
    phoneHref: settings?.phone ? `tel:${String(settings.phone).replace(/[^+\d]/g, "")}` : null,
    emailHref: settings?.email ? `mailto:${settings.email}` : null,
  };

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useSettings = () => useContext(Ctx);
